import { useEffect, useState } from 'react';
import Modal from '@/components/base/Modal';

type Props = {
  open: boolean;
  studentName: string;
  absenceDate: string;
  initialDate: string | null;
  initialTime: string | null;
  onClose: () => void;
  onSave: (date: string, time: string) => void;
};

export default function MakeupScheduleModal({
  open,
  studentName,
  absenceDate,
  initialDate,
  initialTime,
  onClose,
  onSave,
}: Props) {
  const [date, setDate] = useState(initialDate || '');
  const [time, setTime] = useState(initialTime || '');

  useEffect(() => {
    if (open) {
      setDate(initialDate || '');
      setTime(initialTime || '');
    }
  }, [open, initialDate, initialTime]);

  const inputClass =
    'rounded-md border border-background-300 bg-white px-3 py-2 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-500 focus:ring-2 focus:ring-primary-200';

  return (
    <Modal open={open} title={`${studentName} 보충 일정 잡기`} onClose={onClose}>
      <p className="text-sm text-foreground-500">
        결석일 {absenceDate}. 보충 날짜와 시간을 지정하면 ‘결석보충달력’에 바로 반영돼요.
      </p>

      <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <label className="mb-1 block text-xs font-medium text-foreground-500">
            보충 날짜 <span className="text-accent-600">*</span>
          </label>
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            className={`${inputClass} w-full`}
          />
        </div>
        <div>
          <label className="mb-1 block text-xs font-medium text-foreground-500">보충 시간</label>
          <input
            type="time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            className={`${inputClass} w-full`}
          />
        </div>
      </div>

      <div className="mt-6 flex justify-end gap-2">
        <button
          onClick={onClose}
          className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-600 hover:bg-background-100"
        >
          취소
        </button>
        <button
          onClick={() => date && onSave(date, time)}
          disabled={!date}
          className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-50"
        >
          보충 일정 저장
        </button>
      </div>
    </Modal>
  );
}